import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import BackupsMonitoring from 'components/DialogUTM/components/BackupsMonitoring';
import GettingStarted from 'components/DialogUTM/components/GettingStarted';
import GrowthScale from 'components/DialogUTM/components/GrowthScale';
import SecuritySetup from 'components/DialogUTM/components/SecuritySetup';
import AdvancedDDosProtection from './components/AdvancedDDosProtection';
import AdvancedVPSToolsUptime from './components/AdvancedVPSToolsUptime';
import CompleteSetUp from './components/CompleteSetUp';
import PerformanceOptimization from './components/PerformanceOptimization';

const CAMPAIGN_VPS_WELCOME = 'vpswelcome';
const CAMPAIGN_DEDICATED_WELCOME = 'dedicatedwelcome';
const CAMPAIGN_VPS_SECURITY_SETUP = 'vpssecuritysetup';
const CAMPAIGN_DEDICATED_SECURITY_SETUP = 'dedicatedsecuritysetup';
const CAMPAIGN_VPS_ADV_TOOLS_UPTIME = 'vpsadvtoolsuptime';
const CAMPAIGN_DEDICATED_ADV_TOOLS_UPTIME = 'dedicatedadvtoolsuptime';
const CAMPAIGN_VPS_BACKUPS_AND_MONITORING = 'vpsbackupsmonitoring';
const CAMPAIGN_DEDICATED_BACKUPS_AND_MONITORING = 'dedicatedbackupsmonitoring';
const CAMPAIGN_VPS_PERFORMANCE_OPTIMIZATION = 'vpsperformanceoptimization';
const CAMPAIGN_DEDICATED_PERFORMANCE_OPTIMIZATION =
	'dedicatedperformanceoptimization';
// const CAMPAIGN_ADVANCE_TOOLS_AND_UPTIME = 'advance_tools_and_uptime';
export const CAMPAIGN_VPS_GROWTH_SCALE = 'vpsgrowthscale';
export const CAMPAIGN_DEDICATED_GROWTH_SCALE = 'dedicatedgrowthscale';
const CAMPAIGN_VPS_COMPLETE_YOUR_SETUP = 'vpsmidjourney';
const CAMPAIGN_DEDICATED_COMPLETE_YOUR_SETUP = 'dedicatedmidjourney';

const campaigns = [
	CAMPAIGN_VPS_WELCOME,
	CAMPAIGN_DEDICATED_WELCOME,
	CAMPAIGN_VPS_SECURITY_SETUP,
	CAMPAIGN_DEDICATED_SECURITY_SETUP,
	CAMPAIGN_VPS_ADV_TOOLS_UPTIME,
	CAMPAIGN_DEDICATED_ADV_TOOLS_UPTIME,
	CAMPAIGN_VPS_BACKUPS_AND_MONITORING,
	CAMPAIGN_DEDICATED_BACKUPS_AND_MONITORING,
	CAMPAIGN_VPS_PERFORMANCE_OPTIMIZATION,
	CAMPAIGN_DEDICATED_PERFORMANCE_OPTIMIZATION,
	CAMPAIGN_VPS_GROWTH_SCALE,
	CAMPAIGN_DEDICATED_GROWTH_SCALE,
	CAMPAIGN_VPS_COMPLETE_YOUR_SETUP,
	CAMPAIGN_DEDICATED_COMPLETE_YOUR_SETUP,
];

const DialogUTMWrapper = () => {
	const history = useHistory();
	const location = useLocation();

	const campaign = useMemo(() => {
		const searchParams = new URLSearchParams(location.search);
		return searchParams.get('utm_campaign') || '';
	}, [location.search]);

	const handleClose = () => {
		if (campaign) {
			const params = new URLSearchParams(location.search);
			params.delete('utm_campaign');
			const search = params.toString();
			const url = search ? `${location.pathname}?${search}` : location.pathname;
			history.replace(url);
		}
	};

	if (!campaigns.includes(campaign)) {
		return null;
	}

	if (
		campaign === CAMPAIGN_VPS_WELCOME ||
		campaign === CAMPAIGN_DEDICATED_WELCOME
	)
		return <GettingStarted open={Boolean(campaign)} onClose={handleClose} />;

	if (campaign === CAMPAIGN_VPS_ADV_TOOLS_UPTIME)
		return (
			<AdvancedVPSToolsUptime open={Boolean(campaign)} onClose={handleClose} />
		);

	if (campaign === CAMPAIGN_DEDICATED_ADV_TOOLS_UPTIME)
		return (
			<AdvancedDDosProtection open={Boolean(campaign)} onClose={handleClose} />
		);

	if (
		campaign === CAMPAIGN_VPS_BACKUPS_AND_MONITORING ||
		campaign === CAMPAIGN_DEDICATED_BACKUPS_AND_MONITORING
	)
		return <BackupsMonitoring open={Boolean(campaign)} onClose={handleClose} />;

	if (
		campaign === CAMPAIGN_VPS_SECURITY_SETUP ||
		campaign === CAMPAIGN_DEDICATED_SECURITY_SETUP
	)
		return <SecuritySetup open={Boolean(campaign)} onClose={handleClose} />;

	if (
		campaign === CAMPAIGN_VPS_GROWTH_SCALE ||
		campaign === CAMPAIGN_DEDICATED_GROWTH_SCALE
	)
		return (
			<GrowthScale
				open={Boolean(campaign)}
				onClose={handleClose}
				campaign={campaign}
			/>
		);

	if (
		campaign === CAMPAIGN_VPS_PERFORMANCE_OPTIMIZATION ||
		campaign === CAMPAIGN_DEDICATED_PERFORMANCE_OPTIMIZATION
	)
		return (
			<PerformanceOptimization open={Boolean(campaign)} onClose={handleClose} />
		);

	if (
		campaign === CAMPAIGN_VPS_COMPLETE_YOUR_SETUP ||
		campaign === CAMPAIGN_DEDICATED_COMPLETE_YOUR_SETUP
	)
		return <CompleteSetUp open={Boolean(campaign)} onClose={handleClose} />;

	return null;
};

export default DialogUTMWrapper;
